$(document).ready(function() {

    var footer_trigger = document.querySelector('[footer-form-trigger]'),
        footer_target = document.querySelector('[footer-form-target]');

    if ( footer_trigger && footer_target ) {
        footer_trigger.addEventListener('click', function(e){
            e.preventDefault();

            footer_trigger.classList.toggle('is-active');
            footer_target.classList.toggle('is-active');

            if ( footer_target.classList.contains('is-active')) {
                $('html, body').animate({
                    scrollTop: $(footer_trigger).offset().top
                }, 400);
            }
        });
    }
});
